// Generic modal-visibility key (same registry as openModal/closeModal).
export const BULK_ARCHIVE_DRAWER = 'BulkArchiveDrawer';

export const BULK_ARCHIVE_DRAWER_WIDTH = 920;

export const BULK_CREATE_DRAWER = 'BulkCreateUsersDrawer';

export const BULK_CREATE_DRAWER_WIDTH = 920;
